export default __webpack_public_path__ + "static/media/IMG_4979.a518f9d6.png";